<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/purchaseDelivery/add')">新增</el-button>
        <el-button type="primary" v-if="hasExport" @click="exportYcnDelivery">导出提货统计</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <el-form-item label="提货ID" prop="deliveryId">
          <el-input v-model.trim="searchForm.deliveryId" placeholder="请输入提货ID" clearable />
        </el-form-item>
        <el-form-item label="订单ID" prop="orderId">
          <el-input v-model.trim="searchForm.orderId" placeholder="请输入订单ID" clearable />
        </el-form-item>
        <el-form-item label="合同标题" prop="orderTitle">
          <el-input v-model.trim="searchForm.orderTitle" placeholder="请输入合同标题" clearable />
        </el-form-item>
        <el-form-item label="供应商" prop="userId">
          <el-select v-model="searchForm.userId" clearable filterable placeholder="请选择供应商">
            <el-option v-for="(item) of supplierArr" :value="item.userId" :label="item.userName"
              :key="item.userId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="发货状态" prop="deliveryState">
          <el-select v-model.trim="searchForm.deliveryState" clearable filterable placeholder="请选择发货状态">
            <el-option v-for="[key, value] of deliveryStateMap" :value="key" :label="value" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="deliveryDate" label="提货日期">
          <el-date-picker v-model="searchForm.deliveryDate" placeholder="请选择提货日期" type="date" clearable
            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">

      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="提货ID" prop="deliveryId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="订单ID" prop="orderId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="合同标题" prop="orderTitle"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="合同编号" prop="orderNum"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="应付金额" prop="yingfPrice"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="已付金额" prop="paidPrice"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="供应商" prop="supplierName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="发货状态" prop="deliveryState">
          <template v-slot="{ row }">
            {{ deliveryStateMap.get(row.deliveryState) }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="140" label="提货日期" prop="deliveryDate"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip min-width="140" label="已付价格(元)" prop="paidPrice"></el-table-column> -->
        <el-table-column show-overflow-tooltip min-width="140" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="300">
          <template v-slot="{ row }">
            <el-button type="text" v-if="hasCreate && ['2', '3', '5'].includes(row.deliveryState)" @click="createPdf(row.deliveryId)">生成委托单</el-button>
            <el-button type="text" v-if="row.vehicleFile && hasDownload"
              @click="downloadPdf(row.vehicleFile)">下载委托单</el-button>
            <el-button type="text" v-if="hasApproval && row.deliveryState === '1'"
              @click="approve(row.deliveryId)">审批</el-button>
            <el-button type="text" v-if="hasEdit && ['1', '2'].includes(row.deliveryState)"
              @click="$router.push('/purchaseDelivery/edit?deliveryId=' + row.deliveryId)">编辑</el-button>
            <el-button type="text"
              @click="$router.push('/purchaseDelivery/detail?deliveryId=' + row.deliveryId)">详情</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.deliveryId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

    <PurchaseDeliveryDialog :dataInfo="formData" v-if="approveVisible" @closeDlg="approveVisible = false"
      @successSave="loadData" :showDlg.sync="approveVisible"></PurchaseDeliveryDialog>
  </div>
</template>

<script>
import PurchaseDeliveryDialog from '@/views/purchaseDelivery/PurchaseDeliveryDialog.vue'

import { deliveryState } from '@/utils/dict'
import { downloadExcelFile } from '@/utils/globalMethods'
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'PurchaseDelivery',
  mixins: [keepAlive],
  components: {
    PurchaseDeliveryDialog
  },
  data() {
    return {
      deliveryStateMap: deliveryState,
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        orderTitle: '',
        deliveryId: null,
        orderId: null,
        userId: null,
        deliveryState: null,
        deliveryDate: null
      },
      orderList: [],
      supplierArr: [],
      approveVisible: false,
      formData: {}
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    hasCreate() {
      return this.buttonList.includes('create')
    },
    hasDownload() {
      return this.buttonList.includes('download')
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    },
    userId() {
      return this.$route.query.userId
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    userInfo() {
      return this.$store.state.user
    }
  },
  created() {
    if (this.userId) {
      this.searchForm.userId = this.userId
    }
    this.loadData()
    this.loadUser()
  },
  methods: {
    approve(deliveryId) {
      this.loadDetail(deliveryId)
    },
    loadDetail(deliveryId) {
      this.$axios.get(this.$apis.purchaseDelivery.selectYcDeliveryByDeliveryId, {
        params: { deliveryId }
      }).then(res => {
        this.approveVisible = true
        res.fileList = res.fileList || []
        res.specList.forEach(item => {
          item.fileList = item.fileList || []
        })
        this.formData = res || {}
      })
    },
    exportYcnDelivery() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })

      this.$axios.post(this.$apis.purchaseDelivery.exportYcnDelivery, {
        ...this.searchForm,
        createUserId: this.userInfo.userId
      }, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          downloadExcelFile(res.data, '提货订单统计')
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    createPdf(deliveryId) {
      this.$axios.post(this.$apis.purchaseDelivery.ycDeliveryByToPdf, {
        deliveryId
      }).then(() => {
        this.loadData()
      })
    },
    loadUser() {
      // this.$axios.get(this.$apis.system.selectSysUserByPage, { userType: '4' }).then(res => {
      //   this.supplierArr = res.list || []
      // })
      this.$axios.get(this.$apis.common.selectIparkUserByList, { userType: '4' }).then(res => {
        this.supplierArr = res || []
      })
    },
    downloadPdf(url) {
      window.open(url + '?download=1', '_blank')
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.purchaseDelivery.selectYcDeliveryByList, {
        params: {
          page: this.page,
          size: 10,
          createUserId: this.userInfo.userId,
          ...this.searchForm
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        deliveryId: null,
        orderId: null,
        deliveryState: null,
        deliveryDate: null
      }
      this.loadOrder()
      this.onSearch()
    },

    deleteRow(deliveryId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.purchaseDelivery.deleteYcDelivery, {
          deliveryId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}

.flex-end {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;

  .num {
    color: #007bff;
    margin-right: 15px;

  }
}
</style>
